import { Component, OnInit, Input } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'sd-modal-body',
  templateUrl: './modal-body.component.html',
  styleUrls: [
    '../../../assets/css/scrollbar.scss',
    './modal-body.component.scss'],
})
export class ModalBodyComponent implements OnInit {
  @Input() height = 'auto';
  isMobileOrTablet = false;
  constructor(deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }
  ngOnInit() {
  }
}
